<mode-search
  [searchResults]="getFilteredSearchResults(searchResults$ | async, memberships)"
  [authorizedDomains]="domains"
  [externalSharingEnabled]="externalSharingEnabled"
  (searchInputChange)="search($event)"
  (searchResultClicked)="subscribeEmail.emit($event)"
></mode-search>

<div class="memberships">
  <p *ngIf="memberships.length === 0" class="empty-state" data-test="empty-state">
    Subscribers you select will appear here.
  </p>

  <mode-subscriber-list
    *ngIf="memberships.length > 0"
    [subscribers]="memberships"
    [authorizedDomains]="domains"
    [externalSharingEnabled]="externalSharingEnabled"
    (removeMember)="removeMember.emit($event)"
  ></mode-subscriber-list>
</div>

<mode-info-banner
  [schedule]="schedule"
  [notifyType]="'email'"
  [numberOfSubscribers]="memberships.length"
  data-test="subscription-info-banner"
></mode-info-banner>
